export enum ENoticeUrls {
  NOTICE = 'notices',
  COMMENT = 'comment',
  ATTACHMENT = 'attachment',
  VIEW = 'view',
}
